export default "__VITE_ASSET__7XHlo0Oh__"